class TextMedia {
  constructor(block) {
    this.block = block;

    this.selectors = {
      text: '.js-text-media-text-media',
      media: '.js-text-media-media',
      item: '.js-text-media-item',
    };

    this.DOM = {
      text: this.block.querySelector(this.selectors.text),
      media: this.block.querySelector(this.selectors.media),
      items: this.block.querySelectorAll(this.selectors.item),
    };

    this.init();
  }

  bindResizeEvent() {
    const changeEvent = (event) => {
      if (event.matches) {
        this.moveElement('desktop');
      } else {
        this.moveElement('mobile');
      }
    };

    if (typeof this.breakpoint.addEventListener === 'undefined') {
      this.breakpoint.addListener(changeEvent);
    } else {
      this.breakpoint.addEventListener('change', changeEvent);
    }
  }

  init() {
    if (!this.block || !this.DOM.items.length) {
      return;
    }

    this.breakpoint = window.matchMedia('(min-width: 768px)');
    this.bindResizeEvent();

    if (!this.breakpoint.matches) {
      this.moveElement('mobile');
    }
  }

  moveElement(destination) {
    let items = [];
    if (destination === 'mobile') {
      items = this.DOM.media.querySelectorAll(this.selectors.item);

      items.forEach((item) => {
        this.DOM.text.appendChild(item);
      });
    } else {
      items = this.DOM.text.querySelectorAll(this.selectors.item);

      if (items.length) {
        items.forEach((item) => {
          this.DOM.media.appendChild(item);
        });
      }
    }
  }
}

export default () => {
  const textMediaBlocks = document.querySelectorAll('.js-text-media');

  if (textMediaBlocks.length) {
    textMediaBlocks.forEach((block) => new TextMedia(block));
  }
};
